import styled from 'styled-components';
import {
  COLOR_BACKGROUND_GREY_050,
  COLOR_BACKGROUND_GREY_25,
  COLOR_BLACK,
  COLOR_BLUE,
  COLOR_BLUE_015,
  COLOR_GREEN,
} from '@common/assets/styles/colors';
import PAGE_STYLES from '../../helpers/page-styles';

export default styled.div`
  ${PAGE_STYLES};

  position: relative;
  flex-grow: 1;

  padding-left: 20px;
  padding-right: 20px;

  .header {
    > h4 {
      font-weight: 700;
      line-height: 20px;
      text-align: center;

      margin-bottom: 12px;
    }

    > span {
      margin-top: 16px;
      font-style: normal;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      display: block;
      color: ${COLOR_BLACK};
    }
  }
  
  .list {
    overflow-y: auto;
  }

  div.loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ theme }) =>
      theme.responsive ? 'calc(100% - 80px)' : '240px'};

    > div {
      height: 30px;
      width: 30px;
    }
  }
`;

export const InstitutionExpertiseRowSC = styled.div<{ selected: boolean }>`
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
  cursor: pointer;

  ${({ selected }) =>
    selected
      ? `background-color: ${COLOR_BACKGROUND_GREY_050};`
      : `background-color: ${COLOR_BACKGROUND_GREY_25};`}
  &:hover {
    background-color: ${COLOR_BACKGROUND_GREY_050};
  }

  & > span.mi-name {
    color: ${COLOR_BLACK};
    font-size: 17px;
    line-height: 20px;
    display: block;
    margin-bottom: 4px;
  }

  & > span {
    font-size: 14px;
    line-height: 20px;
    color: ${COLOR_BLUE};
  }

  & > div.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    height: 20px;

    > span {
      &.expertise-tag {
        padding: 2px 16px;
        font-weight: 600;
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        color: ${COLOR_BLUE};
        background-color: ${COLOR_BLUE_015};
        border-radius: 16px;
      }
    }

    & > div {
      & > img {
        padding-bottom: 2px;
        margin-right: 8px;
      }

      & > span.available-slots {
        color: ${COLOR_GREEN};
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;
